<template>
    <UIExampleIncompleteNotice></UIExampleIncompleteNotice>
    <p>
        We have 3 versions of the header for websites:
    </p>
    <UIBulletList :items="versionList"></UIBulletList>


    <h4>Default header</h4>
    <p>Use the default header on our website.</p>
    <UIExampleContainer :componentId="'HeaderDefault'" :name="'Default Header'" :vueComponent="vueDefComponent" :vueCode="vueDefCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>


    <h4>Transactional header</h4>
    <p>Use the transactional header for transactional journeys on the our website.</p>
    <p>We have found that the full header can be distracting whenm used in a transactional context.</p>
    <UIExampleContainer :componentId="'HeaderTransactional'" :name="'Transactional Header'" :vueComponent="vueTransComponent" :vueCode="vueTransCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>


    <h4>The portal/account header</h4>
    <UIExampleIncompleteNotice></UIExampleIncompleteNotice>


    <h4>Common Components</h4>
    <h5>Logo</h5>
    <UIExampleContainer :componentId="'HeaderLogo'" :name="'Logo'" :vueComponent="vueLogoComponent" :vueCode="vueLogoCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>

    <h5>Search</h5>
    <UIExampleContainer :componentId="'HeaderSearch'" :name="'Search'" :vueComponent="vueSearchComponent" :vueCode="vueSearchCode" :singleViewRouteName="'uiComponentFullPage'"></UIExampleContainer>

</template>

<script>
    import { defineComponent } from 'vue';
    import { default as UIExampleContainer } from '../../UIExampleContainer.vue';
    import { default as UIExampleIncompleteNotice } from '../UIExampleIncompleteNotice.vue';
    import { default as UIExamplePlaceholder } from '../UIExamplePlaceholder.vue';
    import { default as UIBulletList } from '../UIBulletList.vue';

    import { default as ExampleDefaultComponent } from './DefaultHeader.vue';
    import ExampleDefaultCode from '!!raw-loader!./DefaultHeader.vue';
    import { default as ExampleTransComponent } from './TransactionalHeader.vue';
    import ExampleTransCode from '!!raw-loader!./TransactionalHeader.vue';

    import { default as ExampleLogoComponent } from './Logo.vue';
    import ExampleLogoCode from '!!raw-loader!./Logo.vue';
    import { default as ExampleSearchComponent } from './Search.vue';
    import ExampleSearchCode from '!!raw-loader!./Search.vue';

    export default defineComponent({
        name: "Header",
        components: {
            UIExampleContainer,
            UIExampleIncompleteNotice,
            UIExamplePlaceholder,
            UIBulletList
        },
        setup(_props, _context) {
            return {
                vueDefComponent: ExampleDefaultComponent,
                vueDefCode: ExampleDefaultCode,
                vueTransComponent: ExampleTransComponent,
                vueTransCode: ExampleTransCode,

                vueLogoComponent: ExampleLogoComponent, 
                vueLogoCode: ExampleLogoCode,
                vueSearchComponent: ExampleSearchComponent,
                vueSearchCode: ExampleSearchCode,

                versionList: [
                    { text: 'The default header' },
                    { text: 'The transactional header' },
                    { text: 'The portal/account header' }
                ]
            }
        }
    });
</script>